'use client';

import Login from './login';

const Index = () => {
  return <><Login /></>;
};

export default Index;
